import { useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { Filter, filtersSchema } from "@/lib/filter";
import { DefaultOverlay } from "../../default-overlay";
import { AllEndpointsTable } from "../endpoint-tables/all-endpoints-table";

const overlay = "endpoints";

export const endpointsSchema = z.tuple([z.literal(overlay)]).or(
  z.tuple([
    z.literal(overlay),
    z.object({
      filters: filtersSchema.optional().catch([]),
    }),
  ]),
);

export type EndpointsSchema = NonNullable<z.infer<typeof endpointsSchema>[1]>;

const DEFAULT_FILTERS: never[] = [];

export function EndpointsOverlay({
  filters = DEFAULT_FILTERS,
}: EndpointsSchema) {
  const navigate = useNavigate();

  const onFilter = (filters: Filter[]) =>
    navigate({
      to: window.location.pathname,
      params: (prev) => prev,
      search: (prev) => ({
        ...prev,
        overlay: [overlay, { filters }],
      }),
    });

  return (
    <DefaultOverlay title="All Endpoints" defaultSize={60}>
      <div className="h-full overflow-hidden p-4 pb-0">
        <AllEndpointsTable filters={filters} onFilter={onFilter} />
      </div>
    </DefaultOverlay>
  );
}
